import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ShopListPage = lazy(() => import('../pages/shop-list/page'));
const ProductPage = lazy(() => import('../pages/product/page'));
const UsedPartsListPage = lazy(() => import('../pages/used-parts-list/page'));
const UsedPartPage = lazy(() => import('../pages/used-part/page'));
const VehicleSelectPage = lazy(() => import('../pages/vehicle-select/page'));
const CommunityPage = lazy(() => import('../pages/community/page'));
const MediaPage = lazy(() => import('../pages/media/page'));
const EventsPage = lazy(() => import('../pages/events/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const GuidePage = lazy(() => import('../pages/guide/page'));
const ShopNaviPage = lazy(() => import('../pages/shop-navi/page'));
const CartPage = lazy(() => import('../pages/cart/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/shop',
    element: <ShopListPage />,
  },
  {
    path: '/product/:id',
    element: <ProductPage />,
  },
  {
    path: '/used-parts',
    element: <UsedPartsListPage />,
  },
  {
    path: '/used-part/:id',
    element: <UsedPartPage />,
  },
  {
    path: '/vehicle-select',
    element: <VehicleSelectPage />,
  },
  {
    path: '/community',
    element: <CommunityPage />,
  },
  {
    path: '/media',
    element: <MediaPage />,
  },
  {
    path: '/events',
    element: <EventsPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/guide',
    element: <GuidePage />,
  },
  {
    path: '/shop-navi',
    element: <ShopNaviPage />,
  },
  {
    path: '/cart',
    element: <CartPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
